import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { logOut } from "../redux/globalSlice"
import { markExplicitSignOut, useSession } from "./session"
import { LOGIN_URL } from "./amplify"

// Full sign-out: clears redux state, revokes the refresh token and clears
// the shared session cookies (which signs out buy. and the widget too),
// then lands on the login app's sign-in page — or on `landing` (a full
// URL) when the caller has somewhere more specific in mind (the guest
// purchase landing sends people to sign in with another address). `global`
// additionally signs out every device (GlobalSignOut) — the MFA enrollment
// flow needs that. Shared by the sidebar Sign Out button, the MFA
// enrollment flow and the guest purchase page.
export function useSignOut() {
  const dispatch = useDispatch()
  const { signOut } = useSession()

  return useCallback(async (options?: { global?: boolean, landing?: string }) => {
    // App's session gate would otherwise redirect to the login page (with a
    // returnTo) the moment the session ends; this hook navigates itself
    markExplicitSignOut()
    dispatch(logOut())
    try {
      await signOut(options?.global !== undefined ? { global: options.global } : undefined)
    } catch (err) {
      console.error("Sign-out failed:", err)
    }
    window.location.replace(options?.landing ?? `${LOGIN_URL}/login`)
  }, [dispatch, signOut])
}
